import React from 'react';

import { Skeleton } from '@material-ui/lab';

import Card from '../../../Card';
import Divider from '../../../Divider';

import { CardSkeletonProps } from './CardSkeleton.types';

const CardSkeleton: React.FC<CardSkeletonProps> = ({
  size = 3,
  separator = true,
  className
}) => {
  return (
    <Card className={`flex flex-column py4 ${className}`}>
      {Array(size)
        .fill(0)
        .map((_el, ind) => (
          <>
            <Skeleton
              variant="rect"
              key={ind}
              width={150}
              height={16}
              className={`mx3 ${ind !== size - 1 ? 'mb3' : ''}`}
            />
            {ind !== size - 1 && separator && <Divider className="mb3" />}
          </>
        ))}
    </Card>
  );
};
export default CardSkeleton;
export { CardSkeletonProps };
